import classNames from 'classnames'
import type {ReactNode} from 'react'

import styles from './SidebarHeaderShadow.css'

type Props = {
  className?: string
  sidebarCollapsed: boolean
  showShadow: boolean
  children: ReactNode
}

function SidebarHeaderShadow({className, sidebarCollapsed, showShadow, children}: Props) {
  return (
    <div
      className={classNames(className, styles.wrapper, {
        [styles.collapsed]: sidebarCollapsed,
        [styles.shadow]: showShadow,
      })}
    >
      {children}
    </div>
  )
}

export default SidebarHeaderShadow
